import {
  SimpleGrid,
  Paper,
  Text,
  ThemeIcon,
  Group,
  ActionIcon,
  Avatar,
  Box,
  Image,
} from "@mantine/core";
import { AppIcon } from "../common/AppIcon";
import { quickActions } from "../../data/mockData";
import { IconLinkedin } from "../../../../../components/Icons/IconLinkedin";
import { IconGmaps } from "../../../../../components/Icons/IconGmaps";
import { IconUpload } from "@tabler/icons-react";
import avatar1 from "../../../../../assets/icons/avatar1.png";
import avatar2 from "../../../../../assets/icons/avatar2.png";
import avatar3 from "../../../../../assets/icons/avatar3.png";
import avatar4 from "../../../../../assets/icons/avatar4.png";

const CARD_MIN_HEIGHT = 128;

const shadow = "0 1px 8px rgba(0,0,0,0.05)";

function TopRightPlus({ color = "primary" }) {
  return (
    <ActionIcon
      variant="subtle"
      color={color}
      radius="xl"
      style={{ position: "absolute", top: 12, right: 12 }}
      aria-label="Ajouter"
    >
      <AppIcon name="plus" size={20} />
    </ActionIcon>
  );
}

function ChannelsGraphic() {
  return (
    <Group gap={0}>
      <ThemeIcon
        variant="filled"
        color={"white"}
        size={48}
        radius="xl"
        bg={"blue.0"}
      >
        <IconLinkedin name={"linkedin"} size={22} />
      </ThemeIcon>
      <ThemeIcon
        variant="light"
        size={48}
        bg={"yellow.0"}
        radius="xl"
        style={{
          marginLeft: -6,
        }}
      >
        <IconGmaps name={"gmaps"} size={22} />
      </ThemeIcon>
      <ThemeIcon
        variant="light"
        color={"green"}
        size={48}
        radius="xl"
        bg={"green.0"}
        style={{
          marginLeft: -6,
        }}
      >
        <IconUpload name={"upload"} size={22} />
      </ThemeIcon>
    </Group>
  );
}

function AvatarsGraphic() {
  const people = [
    { c: "grape", t: avatar1 },
    { c: "orange", t: avatar2 },
    { c: "teal", t: avatar3 },
    { c: "blue", t: avatar4 },
  ];
  return (
    <Avatar.Group spacing="sm">
      {people.map((p, i) => (
        <Image
          key={i}
          color={p.c}
          radius="xl"
          src={p.t}
          w={48}
          h={48}
          objectFit="contain"
          ml={-12}
        />
      ))}
    </Avatar.Group>
  );
}

function QuickActionCard({ action }) {
  // Primary filled card
  if (action.variant === "primary") {
    return (
      <Paper
        radius="lg"
        p="lg"
        bg="primary.6"
        style={{
          position: "relative",
          minHeight: CARD_MIN_HEIGHT,
          cursor: "pointer",
          boxShadow: shadow,
        }}
      >
        <TopRightPlus color="white" />
        <ThemeIcon
          variant="white"
          color="primary"
          size={52}
          radius="xl"
          style={{ backgroundColor: "rgba(255,255,255,0.18)", color: "#fff" }}
        >
          <AppIcon name={action.icon} size={28} />
        </ThemeIcon>
        <Text c="white" fw={700} fz="xl" mt={20}>
          {action.label}
        </Text>
      </Paper>
    );
  }

  // Dashed "add shortcut" card
  if (action.variant === "dashed") {
    return (
      <Paper
        radius="lg"
        p="lg"
        withBorder
        bg={"#fcfbff"}
        style={{
          minHeight: CARD_MIN_HEIGHT,
          borderStyle: "dashed",
          borderColor: "#edebeb",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: shadow,
        }}
        className="on-hover-opacity"
      >
        <ThemeIcon variant="transparent" color="primary" size={40}>
          <AppIcon name="plus" size={30} />
        </ThemeIcon>
        <Text c="primary.6" fw={600} fz="xl" mt={4}>
          {action.label}
        </Text>
      </Paper>
    );
  }

  // Default cards with a graphic
  return (
    <Paper
      radius="lg"
      p="lg"
      bg={"#fcfbff"}
      withBorder
      style={{
        position: "relative",
        minHeight: CARD_MIN_HEIGHT,
        cursor: "pointer",
        borderColor: "#edebeb",
        boxShadow: shadow,
      }}
      className={action.id === "ai-agent" ? "on-hover-opacity" : undefined}
    >
      <TopRightPlus />
      <Box>
        {action.kind === "avatars" ? <AvatarsGraphic /> : <ChannelsGraphic />}
      </Box>
      <Text fw={700} fz={"xl"} mt={20}>
        {action.label}
      </Text>
    </Paper>
  );
}

export function QuickActions() {
  return (
    <SimpleGrid cols={{ base: 1, xs: 2, lg: 4 }} spacing="md" mb={32} mt={"xl"}>
      {quickActions.map((action) => (
        <QuickActionCard key={action.id} action={action} />
      ))}
    </SimpleGrid>
  );
}

export default QuickActions;
